var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment } from "nativewind/jsx-runtime";
import { FlashList } from '@shopify/flash-list';
import { useInfiniteQuery } from '@tanstack/react-query';
import React from 'react';
import { View } from 'react-native';
import { cn } from '@/utils/cn';
import useAppComponents from '@/hooks/useAppComponents';
import { usePlaceDetailScreenName } from '@/hooks/useFeatureFlags';
import useNavigation from '@/navigation/useNavigation';
import SearchItemCard from '@/screens/SearchScreen/components/SearchItemCard';
import SearchLoading from '@/screens/SearchScreen/components/SearchLoading';
import FavoriteNoResult from './FavoriteNoResult';
export default function FavoriteListView() {
    var _a;
    const navigation = useNavigation();
    const pdpScreen = usePlaceDetailScreenName();
    const { api } = useAppComponents();
    const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } = useInfiniteQuery({
        queryKey: ['FavoritePlaces'],
        queryFn: (_a) => __awaiter(this, [_a], void 0, function* ({ pageParam }) {
            return (yield api.listPlaceFavoritesPost({
                nextToken: pageParam,
                limit: 20,
            })).data;
        }),
        getNextPageParam: lastPage => {
            return lastPage.nextToken;
        },
        initialPageParam: undefined,
    });
    const places = (_a = data === null || data === void 0 ? void 0 : data.pages.flatMap(page => { var _a; return (_a = page.items) !== null && _a !== void 0 ? _a : []; })) !== null && _a !== void 0 ? _a : [];
    return (_jsx(_Fragment, { children: isLoading ? (_jsx(SearchLoading, {})) : places.length === 0 ? (_jsx(FavoriteNoResult, {})) : (_jsx(View, { className: "flex-1", children: _jsx(FlashList, { className: "bg-white", contentContainerClassName: "bg-white pb-[100px]", data: places, renderItem: ({ item, index }) => (_jsx(View, { className: cn('border-gray-20 p-5', index === 0 ? 'border-t-0' : 'border-t-[1px]'), children: _jsx(SearchItemCard, { item: item, isHeightFlex: true, onPress: () => {
                            navigation.navigate(pdpScreen, {
                                placeInfo: {
                                    placeId: item.place.id,
                                },
                                specialAccessibility: item.specialAccessibility,
                            });
                        } }) }, item.place.id)), estimatedItemSize: 220, onEndReached: () => {
                    if (hasNextPage && !isFetchingNextPage) {
                        fetchNextPage();
                    }
                }, onEndReachedThreshold: 0.5 }) })) }));
}
